var module = angular.module('octopusApp.projects');

module.controller('ProjectLogoController', function ($scope, $location, $stateParams, projectState, busy, octopusRepository, octoUploader, octopusClient) {
    var octoUpload = octoUploader.create($scope);

    var projectId = $stateParams.projectId;
    $scope.isLoading = busy.create();
    $scope.isUploading = busy.create();
    $scope.octoUpload = octoUpload;
    $scope.beginReset = beginReset;
    $scope.beginUpload = beginUpload;


    $scope.cancel = function () {
        octoUpload.cancel();

        var form = $("#logoUpload")[0];
        if (form) {
            form.reset();
        }
    };


    function init() {
        $scope.isLoading.promise(projectState.load().then(onProjectLoaded));
    }

    function beginUpload() {
        var url = octopusClient.resolve($scope.project.Links['Logo']);
        $scope.isUploading.promise(octoUpload.begin(url).then(function () {
            $location.path('/projects/' + $scope.project.Id + '/settings');
        }));
    }

    function beginReset() {
        $scope.isUploading.promise(octopusClient.put($scope.project.Links['Logo'], null).then(function () {
            $location.path('/projects/' + $scope.project.Id + '/settings');
        }));
    }

    function onProjectLoaded(project) {
        $scope.project = project;
    }

    init();
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_logo_controller.js
// module id = 2574148710292950
// module chunks = 1